import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TimetablesPage } from './timetables';

@NgModule({
  declarations: [
    TimetablesPage,
  ],
  imports: [
    IonicPageModule.forChild(TimetablesPage),
  ],
})
export class TimetablesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/timetables/timetables.module.ts